import { BaseService } from "@/core/services/BaseService";
import { ENDPOINT } from "@/core/config/Constant";

class ContactService extends BaseService<any> {
  endpoint = ENDPOINT.CONTACT
}

export default new ContactService();